import script from "./EditModelView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditModelView.vue?vue&type=script&setup=true&lang=ts"

import "./EditModelView.vue?vue&type=style&index=0&id=abaef194&lang=scss"

const __exports__ = script;

export default __exports__